import { connect, ConnectedProps } from "react-redux";
import { VacationRentalTermsOfServiceLink } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getVacationRentalListingTermsOfServiceText,
  getVacationRentalListingTermsOfServiceUrl,
} from "../../../shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    vacationRentalListingTermsOfServiceUrl:
      getVacationRentalListingTermsOfServiceUrl(state),
    vacationRentalListingTermsOfServiceText:
      getVacationRentalListingTermsOfServiceText(state),
  };
};

const connector = connect(mapStateToProps);

export type VacationRentalTermsOfServiceLinkConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedVacationRentalTermsOfServiceLink = connector(
  VacationRentalTermsOfServiceLink
);
